/* 
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */

/**
 * This utility function helps to return the distance based on given parameters.
 *
 *  ```typescript
 * 
 *  import {getDistance} from '@ion/dls/src/maps/components/findnearby/helper';
 
 *  const msg = getDistance(marks, value);
 *  ```
 */
export const getDistance = (marks: any[], value: string): number => {
  let val      = 0;
  const length = marks?.length;
  if (length) {
    const min = marks[0].value;
    const max = marks[length - 1].value;
    val = Number(parseFloat(value).toFixed(1));
    
    if (val > max) {
      return max;
    }
    if (val < min) {
      return min;
    }
  }
  return val;
};
